import {
  Box,
  Checkbox,
  CheckboxProps,
  FormControlLabel,
  Tooltip,
} from "@material-ui/core";
import clsx from "clsx";
import { FieldAttributes, useField } from "formik";
import * as React from "react";
import { useSelector } from "react-redux";
import { AppState } from "../../redux";
import { useTranslation } from "react-i18next";
import { useCheckboxStyles } from "../layout/sharedCheckboxStyles";

/**
 * @interface CustomCheckboxProps
 */
interface CustomCheckboxProps {
  label?: string | React.ReactNode;
  small?: boolean;
  tooltipText?: string;
}

/**
 * @component CustomCheckbox using Formik
 * @param {FieldAttributes<unknown> & CustomCheckboxProps & CheckboxProps} props
 * @returns {React.ReactElement}
 */
const CustomCheckbox: React.FunctionComponent<
  FieldAttributes<unknown> & CustomCheckboxProps & CheckboxProps
> = ({ label, ...props }) => {
  const { t } = useTranslation(["layout"]);
  const [field, meta] = useField<unknown>(props);
  const error = meta.error && meta.touched ? meta.error : ""; // get validation error text
  const [focused, setFocused] = React.useState(false);
  const accessibility = useSelector((state: AppState) => state.accessibility);
  const monoMode = accessibility.monoMode;
  const classes = useCheckboxStyles({ monoMode: monoMode, disabled: props.disabled });

  const small = props.small;
  props.small = undefined; /* gives warning when passed to Checkbox */

  return (
    <>
      <FormControlLabel
        style={{ margin: 0 }}
        className={small ? classes.small : classes.large}
        control={
          <Tooltip
            title={
              props.tooltipText
                ? props.tooltipText
                : t("disabled", {
                    ns: "layout",
                  })
            }
            disableHoverListener={!props.disabled}
            arrow
          >
            <Box>
              <Checkbox
                {...field}
                {...props}
                disabled={props.disabled}
                onFocus={() => {
                  setFocused(true);
                }}
                onBlur={() => {
                  setFocused(false);
                }}
                checked={
                  field.value === undefined ? props.checked : (field.value as boolean)
                }
                color="default"
                className={
                  focused ? (accessibility.monoMode ? "focused-mono" : "focused") : ""
                }
                checkedIcon={
                  <span className={clsx(classes.icon, classes.checkedIcon)} />
                }
                icon={<span className={classes.icon} />}
                inputProps={{ "aria-label": "checkbox" }}
              />
            </Box>
          </Tooltip>
        }
        label={label ? <Box style={{ marginLeft: "1.25rem" }}>{label}</Box> : ""}
      />
<Box className="error-text" style={{ color: "red" }}>
  {error}
</Box>    </>
  );
};

export default CustomCheckbox;
